import api from "../api";

// ---------------------------------------------------------------------------
// reportsApi.js
//
// FE wrapper for /api/reports/*. JWT is attached automatically by the axios
// `api` instance, so the backend's CanAccessFinanceReports policy is what
// actually gates access — this is a thin fetch helper.
// ---------------------------------------------------------------------------

/**
 * Fetch the X-Ray finance report.
 * @param {string} [selectDate] YYYY-MM-DD. Omit for backend default (today).
 */
export async function getXRayReport(selectDate) {
    const params = selectDate ? { selectDate } : {};
    const res = await api.get("/reports/xray", { params });
    return res.data;
}

/**
 * Fetch an On-Time Delivery report (Planning).
 * @param {string} reportKey "summary-otd" | "blown-up"
 * @param {object} [opts] { firstDate, secondDate, customer, productGroup, partNum } (YYYY-MM-DD for dates)
 */
export async function getOtdReport(reportKey, opts = {}) {
    const params = {};
    ["firstDate", "secondDate", "customer", "productGroup", "partNum"].forEach((k) => {
        if (opts[k]) params[k] = opts[k];
    });
    const res = await api.get(`/reports/otd/${reportKey}`, { params });
    return res.data;
}

export default { getXRayReport, getOtdReport };
